export enum Sources {
  DASHBOARD = 'dashboard',
  MAIN_MENU = 'mainMenu',
  ASSIGNMENTS = 'assignments',
  ACTIVITIES = 'activities',
}

export enum TelemetryEventTypes {
  ACCESS_PAGE = 'accessPage',
  TEACHING_ORDER_CHANGED = 'teachingOrderChanged',
  ACCESS_RESOURCE = 'accessResource',
  ACCESS_ACTIVITY_PAGE = 'accessActivityPage',
  READ_BOOK = 'readBook',
  VIEW_TAB = 'viewTab',
  ACCESS_LINK = 'accessLink',
  ACCESS_ACTIVITY = 'accessActivity',
  LOGIN_SUCCESS = 'loginSuccess',
}

export enum TelemetryLogTypes {
  GRAPH_ERROR = 'graph-error',
}
